import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('orders')

export const FETCH_ORDERS = createType('FETCH_ORDERS')
export const ORDERS_FETCHED = createType('ORDERS_FETCHED')
export const GET_ORDER = createType('GET_ORDER')
export const GET_ORDER_SUCCESS = createType('GET_ORDER_SUCCESS')
export const UPDATE_ORDER = createType('UPDATE_ORDER')
export const ORDER_UPDATED = createType('ORDER_UPDATED')
export const ADD_MEMO = createType('ADD_MEMO')
export const ADD_MEMO_SUCCESS = createType('ADD_MEMO_SUCCESS')
export const CLOSE_ORDER = createType('CLOSE_ORDER')
export const CLOSE_ORDER_SUCCESS = createType('CLOSE_ORDER_SUCCESS')
// export const CREATE_ORDER = createType('CREATE_ORDER')
export const OPEN_CREATE_MODAL = createType('OPEN_CREATE_MODAL')
export const ACCEPT_ORDER = createType('ACCEPT_ORDER')
export const ADD_ORDER = createType('ADD_ORDER')
export const SHOW_ASSIGN_DIALOG = createType('SHOW_ASSIGN_DIALOG')
export const SHOW_APPEAL_DIALOG = createType('SHOW_APPEAL_DIALOG')
export const SHOW_PRICE_DIALOG = createType('SHOW_PRICE_DIALOG')
export const SHOW_SERVICE_TIME_DIALOG = createType('SHOW_SERVICE_TIME_DIALOG')
export const SHOW_ASSIGN_WORKER_DIALOG = createType('SHOW_ASSIGN_WORKER_DIALOG')
export const SHOW_ASSIGN_WORKER_SELECT_DIALOG = createType('SHOW_ASSIGN_WORKER_SELECT_DIALOG')
// export const SET_WAIT_EXPRESS_STATUS = createType('SET_WAIT_EXPRESS_STATUS')
export const SET_COMPLETE_STATUS = createType('SET_COMPLETE_STATUS')
export const SET_WORKER_COMPLETE = createType('SET_WORKER_COMPLETE')
export const TOGGLE_ORDER_TAG = createType('TOGGLE_ORDER_TAG')
export const LOCK_ORDER_FEE = createType('LOCK_ORDER_FEE')
export const ORDER_PREVIEW = createType('ORDER_PREVIEW')
export const CONFIRM_LOCATION = createType('CONFIRM_LOCATION')
export const SHOW_CREATE_ORDER_DIALOG = createType('SHOW_CREATE_ORDER_DIALOG')
export const SHOW_IMAGE_VIEW_DIALOG = createType('SHOW_IMAGE_VIEW_DIALOG')
export const ORDER_DEDUCTION = createType('ORDER_DEDUCTION')
export const SET_ACCEPT_STATUS = createType('SET_ACCEPT_STATUS')
export const RE_SERVICE_DIALOG = createType('RE_SERVICE_DIALOG')
export const SEND_WORKER_TO_USER = createType('SEND_WORKER_TO_USER')
export const TENANT_CLOSE_ORDER = createType('TENANT_CLOSE_ORDER')
export const REFUSE_CLOSE_ORDER = createType('REFUSE_CLOSE_ORDER')
export const SHOW_EXPRESS_DIALOG = createType('SHOW_EXPRESS_DIALOG')
export const SHOW_EXPRESS_DETAIL_DIALOG = createType('SHOW_EXPRESS_DETAIL_DIALOG')
export const SHOW_ACCESSORY_DETAIL_DIALOG = createType('SHOW_ACCESSORY_DETAIL_DIALOG')
export const SAVE_ORDER_ACCESSORY = createType('SAVE_ORDER_ACCESSORY')
export const SHOW_ORDER_EVALUATE_DIALOG = createType('SHOW_ORDER_EVALUATE_DIALOG')
export const TASK_FETCHED = createType('TASK_FETCHED')
export const SHOW_ORDER_REMINDER = createType('SHOW_ORDER_REMINDER')







